import { useState } from "react";

const API_URL = process.env.REACT_APP_API_URL as string;

export default function RegisterForm() {
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    street: "",
    city: "",
    country: "",
    company: "",
    companyStreet: "",
    companyCity: "",
    companyCountry: "",
  });

  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    try {
      const response = await fetch(`${API_URL}/api/users/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Registration failed");
      }

      setMessage("Registration successful. Please verify your email.");

      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    } catch (err: any) {
      setError(err.message);
    }
  };

  const inputStyle =
    "w-full rounded-lg border border-secondary4 px-4 py-2.5 text-sm focus:border-dantzOrange focus:outline-none focus:ring-2 focus:ring-dantzOrange/20";

  return (
    <form
      onSubmit={handleSubmit}
      className="mt-6 w-full max-w-3xl rounded-xl border border-secondary5 bg-white p-8"
    >
      <div className="text-center">
        <h1 className="font-heading text-2xl text-dantzBlue">Create Account</h1>
        <p className="mt-1 text-sm text-secondary4">
          Create your Xpress IP account
        </p>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4">
        <input
          name="title"
          placeholder="Title"
          onChange={handleChange}
          className={inputStyle}
        />
        <input
          name="phone"
          placeholder="Phone"
          onChange={handleChange}
          className={inputStyle}
        />

        <input
          name="firstName"
          placeholder="First Name"
          required
          onChange={handleChange}
          className={inputStyle}
        />
        <input
          name="lastName"
          placeholder="Last Name"
          required
          onChange={handleChange}
          className={inputStyle}
        />

        <input
          name="email"
          type="email"
          placeholder="Email"
          required
          onChange={handleChange}
          className={inputStyle}
        />
        <div />

        <input
          name="password"
          type="password"
          placeholder="Password"
          required
          onChange={handleChange}
          className={inputStyle}
        />
        <input
          name="confirmPassword"
          type="password"
          placeholder="Confirm Password"
          required
          onChange={handleChange}
          className={inputStyle}
        />
      </div>

      <div className="mt-4">
        <h3 className="text-lg font-semibold mb-4 border-b pb-2">
          Company Address
        </h3>
        <input
          name="company"
          required
          placeholder="Company Name"
          onChange={handleChange}
          className={`${inputStyle} mb-4`}
        />
        <input
          name="companyStreet"
          required
          placeholder="Company Street"
          onChange={handleChange}
          className={`${inputStyle} mb-4`}
        />

        <div className="grid grid-cols-2 gap-4">
          <input
            name="companyCity"
            required
            placeholder="Company City"
            onChange={handleChange}
            className={inputStyle}
          />
          <input
            name="companyCountry"
            required
            placeholder="Company Country"
            onChange={handleChange}
            className={inputStyle}
          />
        </div>
      </div>

      <div className="mt-4">
        <h3 className="text-lg font-semibold mb-4 border-b pb-2">
          Private Address
        </h3>
        <input
          name="street"
          placeholder="Street"
          required
          onChange={handleChange}
          className={`${inputStyle} mb-4`}
        />

        <div className="grid grid-cols-2 gap-4">
          <input
            name="city"
            placeholder="City"
            required
            onChange={handleChange}
            className={inputStyle}
          />
          <input
            name="country"
            placeholder="Country"
            required
            onChange={handleChange}
            className={inputStyle}
          />
        </div>
      </div>

      {error && (
        <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600 mt-4">
          {error}
        </div>
      )}
      {message && (
        <div className="rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700 mt-4">
          {message}
        </div>
      )}

      <button
        type="submit"
        className="mt-4 w-full rounded-lg bg-dantzOrange py-2.5 font-medium text-white transition hover:brightness-110 active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dantzBlue"
      >
        Register
      </button>
    </form>
  );
}
